/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venueName: NonNullable<unknown> }} Placelunchflyerscan3Inputs */

const en_placelunchflyerscan3 = /** @type {(inputs: Placelunchflyerscan3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The menu on your phone and everything at ${i?.venueName}`)
};

const de_placelunchflyerscan3 = /** @type {(inputs: Placelunchflyerscan3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Menü am Handy und alles von ${i?.venueName}`)
};

/**
* | output |
* | --- |
* | "The menu on your phone and everything at {venueName}" |
*
* @param {Placelunchflyerscan3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placelunchflyerscan3 = /** @type {((inputs: Placelunchflyerscan3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placelunchflyerscan3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placelunchflyerscan3(inputs)
	return de_placelunchflyerscan3(inputs)
});
export { placelunchflyerscan3 as "placeLunchFlyerScan" }